import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import SvgIcon from './SvgIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LogOutIcon = function LogOutIcon(props) {
  return /*#__PURE__*/_jsx(SvgIcon, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsxs("g", {
      id: "baseline-get_app-24px",
      transform: "translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000)",
      children: [/*#__PURE__*/_jsx("polygon", {
        id: "Path",
        points: "-1.13686838e-13 0 24 0 24 24 -1.13686838e-13 24",
        fill: "none"
      }), /*#__PURE__*/_jsx("path", {
        d: "M19,14 L15,14 L15,8 L9,8 L9,14 L5,14 L12,21 L19,14 Z M5,3 L5,5 L19,5 L19,3 L5,3 Z",
        id: "Shape",
        fillRule: "nonzero"
      })]
    })
  }));
};
export default LogOutIcon;